import { IconName } from '../enums/icon-enum';

export const ICON_PATH: Record<IconName, string> = {
  [IconName.LOGO]: '../assets/icons/icons.svg#logo',
  [IconName.SECONDARY_LOGO]: '../assets/icons/icons.svg#secondary-logo',
  [IconName.CHECKED]: '../assets/icons/icons.svg#checked',
  [IconName.UNCHECKED]: '../assets/icons/icons.svg#unchecked',
  [IconName.LOGOWHITE]: '../assets/icons/icons.svg#logowhite',
  [IconName.YOUTUBE]: '../assets/icons/icons.svg#youtube',
  [IconName.TWITTER]: '../assets/icons/icons.svg#twitter',
  [IconName.INSTAGRAM]: '../assets/icons/icons.svg#instagram',
  [IconName.FACEBOOK_WHITE]: '../assets/icons/icons.svg#facebook-white',
  [IconName.FACEBOOK]: '../assets/icons/icons.svg#facebook',
  [IconName.LINKEDIN]: '../assets/icons/icons.svg#linkedin',
  [IconName.GOOGLE]: '../assets/icons/icons.svg#google',
  [IconName.LOGOHEADER]: '../assets/icons/icons.svg#logoheader',
  [IconName.APPLE]: '../assets/icons/icons.svg#apple',
  [IconName.TWT]: '../assets/icons/icons.svg#twt',
  [IconName.ARROWLEFT]: '../assets/icons/icons.svg#arrowleft',
  [IconName.ARROWRIGHT]: '../assets/icons/icons.svg#arrowright',
  [IconName.NOTIFY]: '../assets/icons/icons-home.svg#notify',
  [IconName.HOME]: '../assets/icons/icons-home.svg#home',
  [IconName.HOMEACTIVE]: '../assets/icons/icons-home.svg#home-active',
  [IconName.INVENTORY]: '../assets/icons/icons-home.svg#inventory',
  [IconName.INVENTORYACTIVE]: '../assets/icons/icons-home.svg#inventory-active',
  [IconName.CUSTOMERS]: '../assets/icons/icons-home.svg#customers',
  [IconName.CUSTOMERSACTIVE]: '../assets/icons/icons-home.svg#customers-active',
  [IconName.ORDERS]: '../assets/icons/icons-home.svg#orders',
  [IconName.ORDERSACTIVE]: '../assets/icons/icons-home.svg#orders-active',
  [IconName.STAFF]: '../assets/icons/icons-home.svg#staff',
  [IconName.STAFFACTIVE]: '../assets/icons/icons-home.svg#staff-active',
  [IconName.BRANDS]: '../assets/icons/icons-home.svg#brands',
  [IconName.BRANDSACTIVE]: '../assets/icons/icons-home.svg#brands-active',
  [IconName.SETTINGS]: '../assets/icons/icons-home.svg#settings',
  [IconName.SETTINGSACTIVE]: '../assets/icons/icons-home.svg#settings-active',
  [IconName.SHOPS]: '../assets/icons/icons-home.svg#shops',
  [IconName.SHOPSACTIVE]: '../assets/icons/icons-home.svg#shops-active',
  [IconName.ADMINS]: '../assets/icons/icons-home.svg#admins',
  [IconName.ADMINSACTIVE]: '../assets/icons/icons-home.svg#admins-active',
  [IconName.PAYMENTS]: '../assets/icons/icons-home.svg#payments',
  [IconName.PAYMENTSACTIVE]: '../assets/icons/icons-home.svg#payments-active',
  [IconName.CONTENT]: '../assets/icons/icons-home.svg#content',
  [IconName.CONTENTACTIVE]: '../assets/icons/icons-home.svg#content-active',
  [IconName.CLOSE]: '../assets/icons/icons-home.svg#close',
  [IconName.CLOSE_SM]: '../assets/icons/icons-home.svg#close-sm',
  [IconName.PROFILE]: '../assets/icons/icons-home.svg#profile',
  [IconName.LOGOUT]: '../assets/icons/icons-home.svg#logout',
  [IconName.PC]: '../assets/icons/icons-home.svg#pc',
  [IconName.MOBILE]: '../assets/icons/icons-home.svg#mobile',
  [IconName.FILTER]: '../assets/icons/inventory-icons.svg#filter',
  [IconName.SCAN]: '../assets/icons/inventory-icons.svg#scan',
  [IconName.EXPORT]: '../assets/icons/inventory-icons.svg#export',
  [IconName.PLUS]: '../assets/icons/inventory-icons.svg#plus',
  [IconName.TRAFFICARROW]: '../assets/icons/inventory-icons.svg#traffic-arrow',
  [IconName.EDIT]: '../assets/icons/inventory-icons.svg#edit',
  [IconName.ARROW_LEFT]: '../assets/icons/inventory-icons.svg#arrow-left',
  [IconName.ARROW_RIGHT]: '../assets/icons/inventory-icons.svg#arrow-right',
  [IconName.FAIL]: '../assets/icons/inventory-icons.svg#fail',
  [IconName.CROSS]: '../assets/icons/inventory-icons.svg#cross',
  [IconName.LOADER]: '../assets/icons/inventory-icons.svg#loader',
  [IconName.EMPRY_INVENTORY]: '../assets/icons/inventory-icons.svg#empty-inventory',
  [IconName.SEARCH]: '../assets/icons/inventory-icons.svg#search',
  [IconName.STAR_LABEL_REQUIRED]: '../assets/icons/inventory-icons.svg#star-label-required',
  [IconName.ARROW_LEFT_2]: '../assets/icons/inventory-icons.svg#arrow-left-2',
  [IconName.PLUS_PAYMENT]: '../assets/icons/subscription-icons.svg#plus',
  [IconName.EDIT_PAYMENT]: '../assets/icons/subscription-icons.svg#edit',
  [IconName.VISA]: '../assets/icons/subscription-icons.svg#visa',
  [IconName.MASTER_CARD]: '../assets/icons/subscription-icons.svg#mastercard',
  [IconName.CVV_HINT_CARD]: '../assets/icons/subscription-icons.svg#icon-cvv-hint',
  [IconName.CVV_HINT_TOOLTIP]: '../assets/icons/subscription-icons.svg#icon-cvv-tooltip',
  [IconName.PAYMENT_CARD_TYPE_VISA]:
    '../assets/icons/subscription-icons.svg#payment-card-type-visa',
  [IconName.PAYMENT_CARD_TYPE_MASTERCARD]:
    '../assets/icons/subscription-icons.svg#payment-card-type-mastercard',
  [IconName.PAYMENT_CARD_TYPE_UNKNOWN]:
    '../assets/icons/subscription-icons.svg#payment-card-type-unknown',
  [IconName.PASSWORD_HINT_CHECK]: '../assets/icons/password-icons.svg#hintcheck',
  [IconName.PASSWORD_HINT_CROSS]: '../assets/icons/password-icons.svg#hintcross',
  [IconName.PASSWORD_EYE]: '../assets/icons/password-icons.svg#eye',
  [IconName.PASSWORD_EYE_HIDE]: '../assets/icons/password-icons.svg#eye-hide',
  [IconName.ARROW_UP_DOWN]: '../assets/icons/active-sessions.svg#arrow-up-down',
  [IconName.COMPUTER]: '../assets/icons/active-sessions.svg#computer',
  [IconName.SMARTPHONE]: '../assets/icons/active-sessions.svg#smartphone',
  [IconName.ACTIVE_SESSIONS_CROSS]: '../assets/icons/active-sessions.svg#cross',
  [IconName.ACTIVE_SESSIONS_SUCCESS]: '../assets/icons/active-sessions.svg#active-sessions-success',
  [IconName.FAILURE]: '../assets/icons/active-sessions.svg#failure',
  [IconName.MODAL_CROSS]: '../assets/icons/icons.svg#modal-cross',
  [IconName.SUCCESS]: '../assets/icons/inventory-icons.svg#success',
  [IconName.PENCIL]: '../assets/icons/icons-home.svg#pencil',
  [IconName.TRASH]: '../assets/icons/icons-home.svg#trash',
  [IconName.ELLIPSIS_VERTICAL]: '../assets/icons/icons.svg#ellipsis-vertical',
  [IconName.CHEVRON_UP]: '../assets/icons/icons.svg#chevron-up',
  [IconName.CHEVRON_DOWN]: '../assets/icons/icons.svg#chevron-down',
  [IconName.VIEW_DETAILS]: '../assets/icons/icons.svg#view-details',
  [IconName.EDIT_PENCIL]: '../assets/icons/icons.svg#edit-pencil',
  [IconName.UPLOAD]: '../assets/icons/inventory-icons.svg#upload',
  [IconName.FILE]: '../assets/icons/file-icon.svg',
  [IconName.SECONDARY_CROSS]: '../assets/icons/icons.svg#secondary-cross',
  [IconName.FILE_INVALID_STATE]: '../assets/icons/file-icon-invalid-state.svg',
  [IconName.GRIP_VERTICAL]: '../assets/icons/product-details/grip-vertical.svg',
  [IconName.TRASH_BIN_LIGHT]: '../assets/icons/product-details/trash-bin.svg',
  [IconName.ADD_ANOTHER_PURPLE_PLUS]: '../assets/icons/product-details/add-another-purple-plus.svg',
  [IconName.SORTABLE_ARROW]: '../assets/icons/orders-icons.svg#sortable-arrow',
  [IconName.VIEW_ORDER]: '../assets/icons/icons.svg#view-order',
  [IconName.EDIT_STATUS]: '../assets/icons/icons.svg#edit-status',
  [IconName.PRINT_ORDER]: '../assets/icons/icons.svg#print-order',
  [IconName.PURPLE_CHECK]: '../assets/icons/icons.svg#purple-check',
  [IconName.CONFIRMATION_ICON]: '../assets/icons/snackbar.svg#confirmation-icon',
  [IconName.MAGNIFYING_GLASS]: '../assets/icons/product-details/magnifying-glass.svg',
  [IconName.ERROR_ICON]: '../assets/icons/snackbar.svg#error-icon',
  [IconName.FEEDBACK]: '../assets/icons/icons-home.svg#feedback',
  [IconName.DRAG_INDICATOR]: '../assets/icons/icons.svg#drag-indicator',
  [IconName.CALENDAR]: '../assets/icons/icons.svg#calendar',
  [IconName.ADD_IMAGE]: '../assets/icons/icons.svg#add-images-icon',
};
